<template>
  <div class="event" :class="{ open: open }">
    <div class="event-hat">
      <div class="event-time">{{ event.time }}</div>
      <div class="event-name">{{ event.home + (event.away ? ' - ' + event.away : '') }}</div>
      <div class="event-result">{{ event.result }}</div>
      <icon-button
        @click="if (event.extra.length || event.more) { open = !open }"
      >
        <arrow-icon v-if="event.extra.length || event.more" :direction="open ? 'up' : 'down'"></arrow-icon>
      </icon-button>
    </div>
    <div class="event-extra">
      <p v-for="(e, i) in event.extra" :key="i"><b>{{ e.name }}</b> - {{ e.value }};</p>
    </div>
  </div>
</template>

<script>
import IconButton from '@/components/buttons/IconButton'
import ArrowIcon from '@/components/icons/ArrowIcon'

export default {
  components: {
    IconButton,
    ArrowIcon
  },
  props: {
    event: Object
  },
  data () {
    return {
      open: false
    }
  }
}
</script>

<style scoped>
.event { overflow: hidden; position: relative; }
.event-hat { align-items: center; display: flex; min-height: 40px; }
.event-time { flex-shrink: 0; text-align: center; width: 80px; }
.event-name { flex: 1; }
.event-result { width: 40%; }
.event-extra { /* border-top: 1px solid #007354; */ display: none; margin-left: 10px; padding: 10px 10px 10px 0; }
.event-extra p:not(:first-child) { margin-top: 5px; }
.event-extra b { color: #713592; font-weight: normal; }
.open.event .event-extra { display: block; }
.white { color: white !important; }
.open.event .event-extra { display: block; }
.icon-button:hover {background: none !important;}
</style>



// WEBPACK FOOTER //
// src/components/results/list/Event.vue